import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const algosecFirewallAnalyzer = defineConnector({
  identifier: "algosecFirewallAnalyzer",
  name: "AlgoSec Firewall Analyzer",
  tagLine: "Firewall policy analysis and compliance",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ apiAddress }) =>
    apiAddress
      ? `${apiAddress.replace(/\./g, "\\.").replace(/\/$/, "")}/.*`
      : "https://.*/.*",
  auth: customAuth("algosecFirewallAnalyzer"),
  steps: [
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "baseUrl",
          label: "API address",
          placeholder: "https://afa.example.com",
          required: true,
          target: { kind: "configuration", field: "apiAddress" },
          helperText: "The base URL of your AlgoSec server.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ apiAddress }) =>
      `${(apiAddress ?? "").replace(/\/$/, "")}/afa/api/v1/devices`,
  },
});
